import { gql } from '@apollo/client'

export const EDIT_EVENT_ATTENDEE_INSURANCE = gql`
  mutation EditEventAttendeeInsurance($inputData: InsuranceInput!) {
    editPaymentInsurance(inputData: $inputData)
  }
`
